import React from 'react'

export default function CoreValue() {
  return (
    <div>
      <div className="w-100 pb-5 stats-container">
                    
                    <div className="container mb-2">
                            <div className="row mt-5">
                                <div className="col-lg-12">
                                    <div className="core-values aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                                    <div className="section-title aos-init aos-animate" data-aos="fade-up">
                                        <h2>Core</h2>
                                        <p>Value<br /></p>
                                    </div>
                                    <div className="row custom-mobile-cols row-cols-md-2 row-cols-lg-4 g-4">
                                        <div className="col">
                                        <div className="value-card">
                                            <div className="value-icon">
                                            <i className="bi bi-bricks"></i>
                                            </div>
                                            <h4>Customized Solutions</h4>
                                            <p>Praesent sapien massa, convallis a pellentesque nec, egestas non nisi.</p>
                                        </div>
                                        </div>

                                        <div className="col">
                                        <div className="value-card">
                                            <div className="value-icon">
                                            <i className="bi bi-shield-check"></i>
                                            </div>
                                            <h4>Durability & Safety Focus</h4>
                                            <p>Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.</p>
                                        </div>
                                        </div>

                                        <div className="col">
                                        <div className="value-card">
                                            <div className="value-icon">
                                            <i className="bi bi-buildings"></i>
                                            </div>
                                            <h4>Innovative Product</h4>
                                            <p>Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.</p>
                                        </div>
                                        </div>

                                        <div className="col">
                                        <div className="value-card">
                                            <div className="value-icon">
                                            <i className="bi bi-tools"></i>
                                            </div>
                                            <h4>End-to-End Support </h4>
                                            <p>Donec sollicitudin molestie malesuada. Curabitur non nulla sit amet nisl tempus.</p>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                    </div>
                </div>
    </div>
  )
}